var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSun({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 3V0H9V3H7Z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 13V16H7V13H9Z",
    fill: "#ffffff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 8C11 9.65685 9.65685 11 8 11C6.34315 11 5 9.65685 5 8C5 6.34315 6.34315 5 8 5C9.65685 5 11 6.34315 11 8Z",
    fill: "#ffffff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 9H3V7H0V9Z",
    fill: "#ffffff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 7H13V9H16V7Z",
    fill: "#ffffff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75735 5.17157L1.63603 3.05025L3.05025 1.63603L5.17157 3.75735L3.75735 5.17157Z",
    fill: "#ffffff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2426 10.8284L14.364 12.9497L12.9497 14.364L10.8284 12.2426L12.2426 10.8284Z",
    fill: "#ffffff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.05025 14.364L5.17157 12.2426L3.75735 10.8284L1.63603 12.9498L3.05025 14.364Z",
    fill: "#ffffff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9497 1.63604L10.8284 3.75736L12.2426 5.17158L14.364 3.05026L12.9497 1.63604Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.8aa39a8dc472065483291a8a4a3c80bb.svg";
export { ForwardRef as ReactComponent };